import { render, staticRenderFns } from "./RaceBtn.vue?vue&type=template&id=222839cd&scoped=true&"
import script from "./RaceBtn.vue?vue&type=script&lang=js&"
export * from "./RaceBtn.vue?vue&type=script&lang=js&"
import style0 from "./RaceBtn.vue?vue&type=style&index=0&id=222839cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222839cd",
  null
  
)

export default component.exports